import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PATHS } from 'src/routes/paths';
import { useAuthContext } from '../auth/useAuthContext';
import LoadingScreen from 'src/components/loading-screen';
import { useCartContext } from './hooks/CartContext';
import { useAddress } from '../../hooks/useAddress';

type GuestGuardProps = {
  children: ReactNode;
  type: 'delivery' | 'takeaway' | 'dinein';
};

export default function OrderGuard({ children, type }: GuestGuardProps) {
  const { address } = useAddress();

  const { isAuthenticated, isInitialized } = useAuthContext();

  const { pathname } = useLocation();

  const { slug_id, shop_id, menu_id, table_id } = useCartContext();

  if (!slug_id || !shop_id || !menu_id) {
    if (slug_id) {
      return <Navigate to={PATHS.home.view(slug_id)} />;
    }
    return <Navigate to={PATHS.home.view('la-urbana-burguer-bar')} />;
  }

  if (type === 'delivery' && !address.text) {
    return <Navigate to={PATHS.delivery.enterAddress.view(slug_id)} />;
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  const paths = {
    delivery: PATHS.delivery.cart.view(slug_id, shop_id, menu_id),
    takeaway: PATHS.takeAway.cart.view(slug_id, shop_id, menu_id),
    dinein: PATHS.dineIn.cart.view(slug_id, shop_id, table_id ?? '', menu_id),
  };
  const pathToGo = paths[type];

  if (isAuthenticated && !pathname.includes('cart') && !pathname.includes('detail-order')) {
    return <Navigate to={pathToGo} />;
  }

  const pathsBack = {
    delivery: PATHS.delivery.menu.view(slug_id, shop_id, menu_id),
    takeaway: PATHS.takeAway.menu.view(slug_id, shop_id, menu_id),
    dinein: PATHS.dineIn.menu.view(slug_id, shop_id, table_id ?? '', menu_id),
  };
  const pathToBack = pathsBack[type];

  if (!isAuthenticated && pathname.includes('cart')) {
    return <Navigate to={pathToBack} />;
  }

  return <>{children}</>;
}
